import { ConflictError, UnauthorizedError } from "../errors/http_errors";
import { Item } from "../models/item";

async function fetchData(input: RequestInfo, init?: RequestInit) {
  const response = await fetch(input, init);

  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const errorMessage = errorBody.error;
    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error(
        "Request failed with status: " +
          response.status +
          " message: " +
          errorMessage
      );
    }
  }
}

export async function fetchItems(gameSetId: string): Promise<Item[]> {
  const response = await fetchData(`${process.env.REACT_APP_API_URL}/api/gameSets/${gameSetId}/items`, {
    method: "GET",
    credentials: "include",
  });
  return response.json();
}

export interface ItemInput {
  question: string;
  solution: string;
}

export async function createItem(
  item: ItemInput,
  gameSetId: string
): Promise<Item> {
  const response = fetchData(`${process.env.REACT_APP_API_URL}/api/gameSets/${gameSetId}/items`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  });
  return (await response).json();
}

export async function updateItem(
  itemId: string,
  item: ItemInput,
  gameSetId: string
): Promise<Item> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/gameSets/${gameSetId}/items/` + itemId,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }
  );
  return (await response).json();
}

export async function deleteItem(itemId: string, gameSetId: string) {
  await fetchData(`${process.env.REACT_APP_API_URL}/api/gameSets/${gameSetId}/items/` + itemId, {
    method: "DELETE",
    credentials: "include",
  });
}
